import { Timestamp } from "firebase/firestore";
import { FirebaseData } from "../General/FirebaseData";
import { UnlocAuthTokenData } from '../Property/Integrations/Unloc';

export class LockHolderAccessTokenData extends FirebaseData {

  token?: UnlocAuthTokenData;
  expireDate?: Date;

  setup(data: any) {
    if (typeof data.token === "object") this.token = data.token;

    if (data.expireDate instanceof Timestamp) {
      this.expireDate = (data.expireDate as Timestamp).toDate();
    } else if (this.isValidDate(data.expireDate)) {
      this.expireDate = data.expireDate;
    }

    super.setup(data);
  }
}
